import { FloatingEdge } from '../../../tabs/CampaignWorkflowTab/components/Canvas';

export const EdgeTypeKeys: { [key in keyof typeof EdgeTypes]: keyof typeof EdgeTypes } = {
  floating: 'floating',
};

export const EdgeTypes = {
  floating: FloatingEdge,
};
